import React from 'react';
import { t } from 'ttag';

import './marketinfo.less';


function DiscountInfo() {
  return (
    <div className="marketInfoContainer">
      <p
        className="discountInfo"
      >
        {t`Excluded from discount vouchers`}
      </p>
    </div>
  );
}

export default DiscountInfo;
